export { ThemeLiquidDocsManager } from './themeLiquidDocsManager';
export {
  Resource,
  Resources,
  downloadResource,
  downloadThemeLiquidDocs,
  root,
} from './themeLiquidDocsDownloader';
